import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, Category } from '../services/api';
import './Catalog.css';

const Catalog: React.FC = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const fetchedCategories = await api.getCategories();
        console.log('Fetched categories:', fetchedCategories);
        setCategories(fetchedCategories);
      } catch (error) {
        console.error('Failed to load categories:', error);
        // Create some default categories if API fails
        const defaultCategories = [
          { id: 1, name: 'Dresses', description: 'Beautiful vintage dresses' },
          { id: 2, name: 'Tops', description: 'Stylish tops and shirts' },
          { id: 3, name: 'Bottoms', description: 'Pants, skirts and shorts' },
          { id: 4, name: 'Accessories', description: 'Bags, jewelry and more' }
        ];
        setCategories(defaultCategories);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  const handleCategoryClick = (categoryName: string) => {
    navigate(`/shop?category=${categoryName.toLowerCase()}`);
  };

  const getCategoryImage = (categoryName: string): string => {
    const categoryImages: { [key: string]: string } = {
      'dresses': '/images/dresses.jpeg',
      'tops': '/images/top.jpeg',
      'bottoms': '/images/shorts.jpeg',
      'accessories': '/images/sunglasses.jpeg',
      'dress': '/images/dresses.jpeg',
      'top': '/images/top.jpeg',
      'bottom': '/images/shorts.jpeg',
      'accessory': '/images/sunglasses.jpeg'
    };
    return categoryImages[categoryName.toLowerCase()] || '/images/dresses.jpeg';
  };

  if (loading) {
    return (
      <div className="catalog-wrapper">
        <div className="catalog-header">
          <h1>Shop by Category</h1>
          <p>Loading categories...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="catalog-wrapper">
      <div className="catalog-header">
        <h1>Shop by Category</h1>
        <p>Discover our curated collection of vintage fashion</p>
      </div>

      <div className="catalog-container">
        <div className="catalog-grid">
          {categories.map((category) => (
            <div 
              key={category.id} 
              className="catalog-card"
              onClick={() => handleCategoryClick(category.name)}
            >
              <div 
                className="catalog-image"
                style={{
                  backgroundImage: `url(${category.image || getCategoryImage(category.name)})`
                }}
              >
                <div className="catalog-overlay">
                  <h3 className="catalog-title">{category.name}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Catalog;